function transformAwardSnapshot(snapshot) {
  const data = typeof snapshot === "string" ? JSON.parse(snapshot) : snapshot;
  const { property, applications, shared_profiles, ...entities } = data;

  const entityIdToSharedProfileId = {};
  if (shared_profiles) {
    for (const [spId, spData] of Object.entries(shared_profiles)) {
      if (spData.application_id) {
        entityIdToSharedProfileId[spData.application_id] = spId;
      } else if (spData.tenantid) {
        entityIdToSharedProfileId[spData.tenantid] = spId;
      }
    }
  }

  function resolveProfileId(entityId) {
    return entityIdToSharedProfileId[entityId] || entityId;
  }

  const guarantorIds = new Set();
  for (const entity of Object.values(entities)) {
    const gIds = entity.tenant?.gurantor_id || [];
    for (const g of gIds) {
      const id = (typeof g === "object" ? g._id : g)?.toString();
      if (id) guarantorIds.add(id);
    }
  }

  function cleanExtraData(extraData) {
    if (!extraData) return null;
    const cleaned = { ...extraData };
    delete cleaned.document_analysis;
    delete cleaned.profileReportContinuation;
    return cleaned;
  }

  function buildTenantObject(entityId, entity) {
    const { tenant, tenant_extra_data, kyc_users } = entity;
    if (!tenant) return null;

    const built = { ...tenant };
    built.onfido_user_kyc = kyc_users;
    built.tenant_extra_field_id = cleanExtraData(tenant_extra_data);
    built.tenantDocs = entity.tenant_docs || [];
    delete built.profileSummary;
    delete built.profileSummaryEs;

    if (built.gurantor_id && Array.isArray(built.gurantor_id)) {
      built.gurantor_id = built.gurantor_id
        .map((g) => {
          const gId = (typeof g === "object" ? g._id : g)?.toString();
          const guarantorEntity = entities[gId];
          if (guarantorEntity) {
            const obj = buildTenantObject(gId, guarantorEntity);
            if (obj) {
              delete obj.profileSummary;
              delete obj.profileSummaryEs;
              return obj;
            }
          }
          return typeof g === "object" ? g : null;
        })
        .filter(Boolean);
    }

    return built;
  }

  const profiles = [];
  const participantTenantIds = new Set();

  if (applications) {
    for (const [appId, appData] of Object.entries(applications)) {
      const participants = (appData.participants || []).map((p) => {
        const tenantEntity = entities[p.id];
        const tenantInfo = tenantEntity
          ? buildTenantObject(p.id, tenantEntity)
          : null;
        if (p.id) participantTenantIds.add(String(p.id));
        return { ...p, tenant_info: tenantInfo };
      });

      const appProfileId = resolveProfileId(appId);
      profiles.push({
        _id: appProfileId,
        application_id: {
          _id: appId,
          title: appData.title,
          participants,
          created_by: appData.created_by,
          skor_protect: appData.skor_protect,
        },
        propertyid: property ? [String(property._id)] : [],
        properties: property ? [property] : [],
      });
    }
  }

  for (const [id, entity] of Object.entries(entities)) {
    if (guarantorIds.has(id) || participantTenantIds.has(id)) continue;

    const tenantid = buildTenantObject(id, entity);
    if (!tenantid) continue;

    const tenantProfileId = resolveProfileId(id);
    profiles.push({
      _id: tenantProfileId,
      tenantid,
      propertyid: property ? [String(property._id)] : [],
      properties: property ? [property] : [],
    });
  }

  return profiles;
}

export { transformAwardSnapshot };
